import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export interface PersonProfileLocationMappingPayload {
  personProfileId: string;
  locationId: number;
}

export function useAddPersonProfileLocationMapping(
  onSuccess?: () => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/person_profile/mapping`;

  const request = new Request(url, {
    method: 'POST',
  });

  return useAuthenticatedMutation<null, PersonProfileLocationMappingPayload>(
    request,
    {
      onSuccessInvalidationKeys: [['person_match_profiles']],
      onSuccess,
      onError,
    }
  );
}

export default useAddPersonProfileLocationMapping;
